import React from 'react'
import { openInGoogleMaps } from '../../utils'
import { HiOutlineLocationMarker } from "react-icons/hi";
import { FaDirections } from "react-icons/fa";

export default function ClubProfileSection({ clublogo, address, distance, name }) {
    return (
        <div className='venues-new-card-text-section'>
            <h1>
                <span className='venues-new-card-img-icon-section-logo'>
                    <img
                        src={clublogo}
                        alt="club-logo"
                        onError={(e) => {
                            e.target.src =
                                "https://img.freepik.com/free-vector/party-neon-sign_540545-36.jpg?semt=ais_hybrid&w=740&q=80";
                        }}
                    />
                </span>
                {name}
            </h1>


            <div className='venues-new-card-text-section-location'>
                <p>
                    <span className='icon-span-24'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="19" viewBox="0 0 16 19" fill="none">
                            <path d="M15 8.31543C15 13.7599 8 18.4265 8 18.4265C8 18.4265 1 13.7599 1 8.31543C1 6.45891 1.7375 4.67844 3.05025 3.36568C4.36301 2.05293 6.14349 1.31543 8 1.31543C9.85652 1.31543 11.637 2.05293 12.9497 3.36568C14.2625 4.67844 15 6.45891 15 8.31543Z" stroke="#4F4F4F" stroke-width="1.16667" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M8.00033 10.6491C9.28899 10.6491 10.3337 9.60442 10.3337 8.31575C10.3337 7.02709 9.28899 5.98242 8.00033 5.98242C6.71166 5.98242 5.66699 7.02709 5.66699 8.31575C5.66699 9.60442 6.71166 10.6491 8.00033 10.6491Z" stroke="#4F4F4F" stroke-width="1.16667" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </span>
                    {address?.length > 24 ? address?.slice(0, 24) + "..." : address}
                </p>
                <div className='venues-new-card-text-section-location-distance' onClick={() => openInGoogleMaps(address)}>
                    <span>
                        <FaDirections />{" "}
                        {distance > 0 ? `${Math.round(distance)} Kms` : "--"}
                    </span>

                </div>
            </div>

        </div>
    )
}
